import { ZEROSIX_ERRORS } from '@config/values/zerosix-errors.values';

export enum ZerosixAssetType {
  VOUCHER = 'voucher',
  REWARD = 'reward',
}

export interface IZerosixAsset {
  id?: string;
  type?: ZerosixAssetType;
  url: string;
  name: string;
  value?: number;
  unit: string;
  code: string;
  expiration_date?: string;
  external_id?: string;
  external_ids: string[];
  minimum_amount?: number;
  is_usable?: boolean;
  level_name?: string;
  points_required?: number;
}

export interface IZerosixCard {
  latent_points_balance?: number;
  terms_accepted: boolean;
  points_balance?: number;
  current_level?: string;
  card_url: string;
  member_summary?: string;
  available_vouchers: IZerosixAsset[];
  rewards: IZerosixAsset[];
}

export interface ZerosixError {
  class: 'ZerosixException';
  code: keyof ZEROSIX_ERRORS; //Code interne
  detail: string; //Trad en anglais si dispo
  data: any[]; //Context eventuel
}
